var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 0C1144.06 2.22311 544.547 35.8092 513.999 152.369C475.813 298.068 1256.11 227.271 1046.59 385.796C828.025 628.457 0 363.222 311.012 683.864C615.492 930.116 85.5827 924.644 0 1024",
    stroke: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M368.682 0C278.526 45.8591 133.874 153.401 276.511 216.697C454.808 295.816 923.215 256.508 723.261 379.471C525.321 479.253 161.004 305.391 46.8407 408.196C-38.7821 485.3 200.574 692.291 152.61 770.029C112.5 835.038 26.5262 870.818 0 894",
    stroke: "#252525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M833 1022C826.5 943.5 838.6 786.1 939 784.5C1064.5 782.5 1109 794 1153.5 744C1198 694 1344.5 516 1387 545C1421 568.2 1438.5 605 1443 620.5",
    stroke: "#252525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 82.0364C1343.87 65.1268 1160.35 60.2529 1195.36 176.034C1239.11 320.76 1392.76 537.601 1141.66 581.367C890.549 625.133 582.757 634.085 702.095 728.58C797.565 804.175 633.144 957.025 539 1024",
    stroke: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login-bg.b67c5f309c11a97fff71de8616e45805.svg";
export { ForwardRef as ReactComponent };